import styled from 'styled-components';

/**
 * Placeholder base class.
 * @type {StyledComponentClass<any, any, *>}
 */
const Placeholder = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  height: 100%;
  justify-content: center;
  padding: 2rem;
  width: 100%;

  [class^="EmptyBody__EmptyViewContainer-"] {
    margin-top: -24px;
  }
`;

/**
 * Empty content placeholder.
 * @type {StyledComponentClass<any, any, *>}
 */
const Empty = styled(Placeholder)`
  align-items: center;
  color: #42526E;
  display: flex;
  flex-direction: column;
  justify-content: center;
  opacity: 0.5;
`;

/**
 * Loading placeholder.
 * @type {StyledComponentClass<any, any, *>}
 */
const Loading = styled(Placeholder)``;

const Message = styled.div`
  font-size: small;
  opacity: 0.8;
  text-transform: capitalize;
`;

export {
  Empty,
  Loading,
  Message,
};
